import { studentBookingClient } from '../client';

import { SagepayEndpoints } from './constants';
import { ProcessMicroPaymentDto } from './dto/ProcessMicroPayment.dto';
import { PostSagepayProcessSuccessResponse, SagepayProcessResponse } from './types';

export const postSagepayProcess = async (basket_id: string): Promise<SagepayProcessResponse> => {
    const { data: response } = await studentBookingClient.post<PostSagepayProcessSuccessResponse>(
        SagepayEndpoints.PostSagepayProcess,
        { basket_id }
    );

    return response.data;
};

export const postSagepayProcessMicroPayment = async (
    payload: ProcessMicroPaymentDto
): Promise<SagepayProcessResponse> => {
    const { data: response } = await studentBookingClient.post<PostSagepayProcessSuccessResponse>(
        SagepayEndpoints.PostSagepayProcessMicroPayment,
        payload.serialisePayment()
    );

    return response.data;
};
